import { FC } from 'react';

import { Box, useTheme } from '@mui/material';
import { components, PlaceholderProps } from 'react-select';

import { LanguageOption } from './locale-picker.types';

export const LocalePickerPlaceholder: FC<PlaceholderProps<LanguageOption, false>> = ({
  children,
  ...props
}) => {
  const { palette } = useTheme();

  return (
    <components.Placeholder {...props}>
      <Box color={palette.grey[200]}>{children}</Box>
    </components.Placeholder>
  );
};
